export var AssetType;
(function (AssetType) {
    AssetType["EQ"] = "EQ";
    AssetType["UnlistedEquity"] = "UEQ";
    AssetType["FixedIncome"] = "FI";
    AssetType["CertOfDeposit"] = "COD";
    AssetType["CommPaper"] = "CP";
    AssetType["NCD"] = "NCD";
    AssetType["Warrant"] = "W";
    AssetType["Bonds"] = "BO";
    AssetType["Debentures"] = "DB";
    AssetType["IndianDepoReceipt"] = "IDR";
    AssetType["PreferenceShare"] = "PS";
    AssetType["CorpFD"] = "CFD";
    AssetType["RBIBonds"] = "RBO";
    AssetType["EC54"] = "54EC";
    AssetType["Derivatives"] = "FnO";
    AssetType["DEquity"] = "DEQ";
    AssetType["DCurrency"] = "DCU";
    AssetType["DCommodity"] = "DCO";
    AssetType["MP"] = "MAP";
    AssetType["Commodity"] = "SGB";
    AssetType["RealEstate"] = "RE";
    AssetType["ETF"] = "ETF";
    AssetType["MutualFund"] = "MF";
    AssetType["PMS"] = "PMS";
    AssetType["AIF"] = "AIF";
    AssetType["StructuredProducts"] = "SP";
    AssetType["INVITS"] = "INVITS";
    AssetType["Currency"] = "Currency";
    AssetType["GovtSecurity"] = "GSC";
    AssetType["savingNinvInsurance"] = "SII";
    AssetType["LIFE_INSURANCE"] = "LI";
    AssetType["CommodityCo"] = "CO";
    AssetType["TreasuryBills"] = "TB";
})(AssetType || (AssetType = {}));
export var AssetCategory;
(function (AssetCategory) {
    //field quote.assetCode=>
    AssetCategory["Equity"] = "EQ";
    AssetCategory["FixedIncome"] = "FI";
    AssetCategory["Derivatives"] = "FnO";
    AssetCategory["ManagedPortfolio"] = "MAP";
    AssetCategory["LifeInsurance"] = "LI";
    AssetCategory["RealEstate"] = "RE";
    AssetCategory["Commodity"] = "CO";
    AssetCategory["Others"] = "Others";
    AssetCategory["Total"] = "Total";
})(AssetCategory || (AssetCategory = {}));
export const assetTypeMappingObj = {
    "Mutual Funds": { assetType: AssetType.MutualFund },
    ETF: { assetType: AssetType.ETF },
    AIF: { assetType: AssetType.AIF },
    PMS: { assetType: AssetType.PMS },
    INVITS: { assetType: AssetType.INVITS },
    "Structured Products": { assetType: AssetType.StructuredProducts },
    "Real Estate": { assetType: AssetType.RealEstate },
    Commodity: { assetType: AssetType.Commodity },
    "Fixed Income": { assetType: AssetType.FixedIncome },
    Derivatives: { assetType: AssetType.Derivatives },
    Equity: { assetType: AssetType.EQ },
};
export var IPNLSubTabs;
(function (IPNLSubTabs) {
    IPNLSubTabs["ALL"] = "pnlAll";
    IPNLSubTabs["EQUITY"] = "equity";
    IPNLSubTabs["DERIVATIVE"] = "derivative";
    IPNLSubTabs["FIXED_INCOME"] = "fixed-income";
    IPNLSubTabs["MANAGED_PORTFOLIO"] = "mp";
    IPNLSubTabs["OTHERS"] = "others";
})(IPNLSubTabs || (IPNLSubTabs = {}));
export const NuvamaProducts = new Map([
    [
        AssetType.EQ,
        {
            display: "Listed Equity",
            value: AssetType.EQ,
        },
    ],
    [
        AssetType.UnlistedEquity,
        {
            display: "Unlisted Equity",
            value: AssetType.UnlistedEquity,
        },
    ],
    [
        AssetType.FixedIncome,
        {
            display: "Fixed Income",
            value: AssetType.FixedIncome,
        },
    ],
    [
        AssetType.CertOfDeposit,
        {
            display: "Certificate Of Deposit",
            value: AssetType.CertOfDeposit,
        },
    ],
    [
        AssetType.CommPaper,
        {
            display: "Commercial Paper",
            value: AssetType.CommPaper,
        },
    ],
    [
        AssetType.NCD,
        {
            display: "Non Convertible Debenture",
            value: AssetType.NCD,
        },
    ],
    [
        AssetType.Warrant,
        {
            display: "Warrant",
            value: AssetType.Warrant,
        },
    ],
    [
        AssetType.Bonds,
        {
            display: "Bonds",
            value: AssetType.Bonds,
        },
    ],
    [
        AssetType.Debentures,
        {
            display: "Debentures",
            value: AssetType.Debentures,
        },
    ],
    [
        AssetType.IndianDepoReceipt,
        {
            display: "Indian Depository Receipt",
            value: AssetType.IndianDepoReceipt,
        },
    ],
    [
        AssetType.CorpFD,
        {
            display: "Corp FD",
            value: AssetType.CorpFD,
        },
    ],
    [
        AssetType.RBIBonds,
        {
            display: "RBI Bonds ",
            value: AssetType.RBIBonds,
        },
    ],
    [
        AssetType.EC54,
        {
            display: "54 EC",
            value: AssetType.EC54,
        },
    ],
    [
        AssetType.Derivatives,
        {
            display: "Derivatives",
            value: AssetType.Derivatives,
        },
    ],
    [
        AssetType.DEquity,
        {
            display: "Derivative Equity",
            value: AssetType.DEquity,
        },
    ],
    [
        AssetType.DCurrency,
        {
            display: "Currency",
            value: AssetType.DCurrency,
        },
    ],
    [
        AssetType.DCommodity,
        {
            display: "Commodity",
            value: AssetType.DCommodity,
        },
    ],
    [
        AssetType.PMS,
        {
            display: "PMS",
            value: AssetType.PMS,
        },
    ],
    [
        AssetType.MutualFund,
        {
            display: "Mutual Fund",
            value: AssetType.MutualFund,
        },
    ],
    [
        AssetType.ETF,
        {
            display: "Exchange Traded Funds",
            value: AssetType.ETF,
        },
    ],
    [
        AssetType.INVITS,
        {
            display: "INVITS",
            value: AssetType.INVITS,
        },
    ],
    [
        AssetType.AIF,
        {
            display: "AIF",
            value: AssetType.AIF,
        },
    ],
    [
        AssetType.StructuredProducts,
        {
            display: "Structured Products",
            value: AssetType.StructuredProducts,
        },
    ],
    [
        AssetType.MP,
        {
            display: "Managed Portfolios",
            value: AssetType.MP,
        },
    ],
    [
        AssetType.GovtSecurity,
        {
            display: "Govt. Securities",
            value: AssetType.GovtSecurity,
        },
    ],
    [
        AssetType.TreasuryBills,
        {
            display: "Treasury Bills",
            value: AssetType.TreasuryBills,
        },
    ],
    [
        AssetType.RealEstate,
        {
            display: "Real Estate",
            value: AssetType.RealEstate,
        },
    ],
    [
        AssetType.Commodity,
        {
            display: "Commodities",
            value: AssetType.Commodity,
        },
    ],
]);
export const NuvamaAssets = new Map([
    [
        AssetCategory.Equity,
        {
            display: "Equity",
            value: AssetCategory.Equity,
        },
    ],
    [
        AssetCategory.FixedIncome,
        {
            display: "Fixed Income",
            value: AssetCategory.FixedIncome,
        },
    ],
    [
        AssetCategory.Derivatives,
        {
            display: "Derivative",
            value: AssetCategory.Derivatives,
        },
    ],
    [
        AssetCategory.ManagedPortfolio,
        {
            display: "Managed Portfolio",
            value: AssetCategory.ManagedPortfolio,
        },
    ],
    [
        AssetCategory.LifeInsurance,
        {
            display: "Life Insurance",
            value: AssetCategory.LifeInsurance,
        },
    ],
    [
        AssetCategory.RealEstate,
        {
            display: "Real Estate",
            value: AssetCategory.RealEstate,
        },
    ],
    [
        AssetCategory.Commodity,
        {
            display: "Commodity",
            value: AssetCategory.Commodity,
        },
    ],
]);
export const TabMapping = [
    { title: "All", tabEventKey: IPNLSubTabs.ALL, assetType: [] },
    {
        title: "Equity",
        tabEventKey: IPNLSubTabs.EQUITY,
        assetType: [AssetType.EQ, AssetType.UnlistedEquity],
    },
    {
        title: "Fixed Income",
        tabEventKey: IPNLSubTabs.FIXED_INCOME,
        assetType: [
            AssetType.FixedIncome,
            AssetType.CertOfDeposit,
            AssetType.CommPaper,
            AssetType.NCD,
            AssetType.Warrant,
            AssetType.Bonds,
            AssetType.Debentures,
            AssetType.IndianDepoReceipt,
            AssetType.PreferenceShare,
            AssetType.CorpFD,
            AssetType.RBIBonds,
            AssetType.EC54,
        ],
    },
    {
        title: "Derivatives",
        tabEventKey: IPNLSubTabs.DERIVATIVE,
        assetType: [
            AssetType.Derivatives,
            AssetType.DEquity,
            AssetType.Currency,
            AssetType.DCommodity,
        ],
    },
    {
        title: "Managed Portfolios",
        tabEventKey: IPNLSubTabs.MANAGED_PORTFOLIO,
        assetType: [
            AssetType.MP,
            AssetType.MutualFund,
            AssetType.ETF,
            AssetType.AIF,
            AssetType.PMS,
            AssetType.INVITS,
            AssetType.StructuredProducts,
        ],
    },
    {
        title: "Others",
        tabEventKey: IPNLSubTabs.OTHERS,
        assetType: [AssetType.RealEstate, AssetType.Commodity],
    },
];
export class PnLReportMainEntityContainer {
    constructor(PnLData, SearchData, FilterData, SortData, IsSummarize) {
        this.PnLData = PnLData;
        this.SearchData = SearchData;
        this.FilterData = FilterData;
        this.SortData = SortData;
        this.IsSummarize = IsSummarize;
    }
}
export var dynamicPNLFilters;
(function (dynamicPNLFilters) {
    dynamicPNLFilters["underlyingAsset"] = "Underlying Asset";
    dynamicPNLFilters["expiryMonth"] = "Expiry Month";
    dynamicPNLFilters["instrumentType"] = "Instrument Type";
    dynamicPNLFilters["optionType"] = "Option Type";
    dynamicPNLFilters["strikePrice"] = "Strike Price";
    dynamicPNLFilters["simpleFilter"] = "Filter By";
    dynamicPNLFilters["assetFilter"] = "Asset Filter";
    dynamicPNLFilters["Filter By"] = "Filter By";
})(dynamicPNLFilters || (dynamicPNLFilters = {}));
